export function money(n: number | string | null | undefined): string {
  if (n === null || n === undefined || n === "") return "—";
  const v = Number(n);
  const frac = Math.abs(v % 1) > 0.0049;
  return (
    "₹" +
    v.toLocaleString("en-IN", {
      minimumFractionDigits: frac ? 2 : 0,
      maximumFractionDigits: 2,
    })
  );
}

export function fmtDate(d?: string | null): string {
  if (!d) return "—";
  const date = new Date(d.length <= 10 ? d + "T00:00:00" : d);
  return date.toLocaleDateString("en-IN", {
    day: "numeric",
    month: "short",
    year: date.getFullYear() === new Date().getFullYear() ? undefined : "numeric",
  });
}

export function fmtDateTime(d?: string | null): string {
  if (!d) return "—";
  return new Date(d).toLocaleString("en-IN", {
    day: "numeric",
    month: "short",
    hour: "numeric",
    minute: "2-digit",
  });
}

export function todayISO(): string {
  const d = new Date();
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}

export function addDaysISO(days: number): string {
  const d = new Date();
  d.setDate(d.getDate() + days);
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 10);
}

/** Relative label for a due date: Today / Tomorrow / Overdue 3d / 12 Oct */
export function dueLabel(d?: string | null): { text: string; tone: "bad" | "warn" | "ok" | "muted" } {
  if (!d) return { text: "No date", tone: "muted" };
  const diff = Math.round(
    (new Date(d + "T00:00:00").getTime() - new Date(todayISO() + "T00:00:00").getTime()) /
      86_400_000,
  );
  if (diff < 0) return { text: `Overdue ${-diff}d`, tone: "bad" };
  if (diff === 0) return { text: "Today", tone: "warn" };
  if (diff === 1) return { text: "Tomorrow", tone: "ok" };
  return { text: fmtDate(d), tone: "muted" };
}

export function initials(name: string): string {
  return (name || "?")
    .split(" ")
    .map((x) => x[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
}

export function toLocalInput(iso?: string | null): string {
  if (!iso) return "";
  const d = new Date(iso);
  d.setMinutes(d.getMinutes() - d.getTimezoneOffset());
  return d.toISOString().slice(0, 16);
}
